// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.ai-email-campaign-container {
  min-height: 100vh;
  margin-top: 20px;
}

.progress-header {
  width: 100%;
  margin: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-left: 35px;
}

.ai-email-campaign-setup {
  background: #ffffff;
  padding: 40px;
  border-radius: 8px;
  max-width: 1300px;
  margin: auto;
}

.progress-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.progress-title {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
}

.progress-step {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
  margin-right: 80px;
}

.progress-track {
  width: 94%;
  height: 15px;
  background: #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #2c68ad;
  transition: width 0.3s ease;
}

.setup-box {
  max-width: 600px;
  margin: 24px auto;
  padding: 32px 24px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  padding-left: 50px;
  padding-right: 30px;
  padding-top: 40px;
  margin-top: 70px;
  margin-bottom: 70px;
}
.setup-box__icon {
  margin-bottom: 16px;
}
.setup-box__icon img {
  width: 56px;
  height: 56px;
}
.setup-box__title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
}
.setup-box__subtitle {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 24px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
}
.setup-box__label {
  display: block;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
}
.setup-box__input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 14px;
  margin-top: 6px;
  outline: none;
}
.setup-box__input:focus {
  border-color: #2c68ad;
  box-shadow: 0 0 0 2px rgba(44, 104, 173, 0.2);
}
.setup-box__hint {
  font-size: 12px;
  color: #6b7280;
  margin: 8px 0 16px;
  text-align: left;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  margin-bottom: 25px;
}
.setup-box__button {
  width: 70%;
  padding: 12px 16px;
  background: #2a73c2;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
  font-family: "Open Sans", sans-serif;
  justify-content: center !important;
}
.setup-box__button:hover {
  background: #3079bb;
}

.setup_text {
  color: #6b7280;
  font-size: 14px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
}

.step-nav {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin: 20px auto 0;
}

.step-nav--categories {
  max-width: 620px;
}

.step-nav--campaign {
  max-width: 520px;
}

.step-nav--with-back {
  justify-content: space-between;
}

.ai-next-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  min-width: 150px; /* keep uniform button size */
  text-align: center;
  font-size: 16px;
  font-family: "Open Sans", sans-serif;
  background-color: #2c68ad !important;
  color: #ffffff !important;
  border: none;
  transition: background 0.2s ease;
  margin-bottom: 0;
}

/* Disabled state */
.ai-next-btn:disabled {
  background: #9ca3af;
  color: #ffffff;
  cursor: not-allowed;
}

/* --- Step 1: Categories --- */
.categories-wrapper {
  display: flex;
  justify-content: center !important;
  align-items: center;
  min-height: 100vh;
  margin-left: 40px;
}

.categories-step {
  background: #ffffff;
  border-radius: 12px;
  padding: 22px 24px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  max-width: 620px;
  width: 100%;
  margin: 24px auto;
  margin-top: 70px;
  border: 1px solid #e5e7eb;
}

.categories-header-grid {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 0 6px;
  margin-bottom: 12px;
}

.categories-header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.categories-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
  margin: 0;
}

.categories-subtitle {
  font-size: 12px;
  font-weight: 400;
  color: #6b7280;
  margin: 0;
  font-family: "Open Sans", sans-serif;
}

.select-all {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  color: #1a1a1a;
  cursor: pointer;
  margin-top: 4px;
}

.select-all input[type=checkbox] {
  width: 14px;
  height: 14px;
  accent-color: #2c68ad;
  margin: 0;
}

.categories-search {
  margin: 12px 0 10px;
}

.search-input-wrapper {
  position: relative;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 14px;
}

.email-search-bar {
  width: 100%;
  height: 38px;
  padding: 0 12px 0 34px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 12px;
  outline: none;
  transition: all 0.2s ease-in-out;
  background-color: #ffffff;
}

.email-search-bar::placeholder {
  color: #9ca3af;
  font-size: 12px;
}

.categories-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
  margin: 28px 42px 16px;
}

.category-item {
  padding: 8px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  background-color: #ffffff;
  transition: all 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
}

.category-item:hover {
  background-color: #f5f6f8;
}

.category-item.selected {
  background-color: rgba(44, 104, 173, 0.15);
  color: #1a1a1a;
  border: 1px solid #2c68ad;
}

.categories-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 40px;
  margin-bottom: 20px;
}

.categories-page-btn {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #fafafa;
  cursor: pointer;
  transition: 0.2s;
  margin-bottom: 5px;
}

.categories-page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.categories-page-info {
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}
.pagination-controls button {
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  cursor: pointer;
  transition: 0.2s;
}
.pagination-controls button:hover:not(:disabled) {
  background: #fafafa;
}
.pagination-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.categories-header-grid {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  margin-bottom: 10px;
  padding: 0 24px;
  min-height: 40px;
}

.success-msg {
  font-size: 14px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
}

.success-msg img {
  width: 20px;
  height: 20px;
}

.select-all {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  color: #1a1a1a;
  gap: 8px;
  cursor: pointer;
}

.select-all input[type=checkbox] {
  width: 20px;
  height: 20px;
  accent-color: #2c68ad;
  margin: 0;
  cursor: pointer;
  border-radius: 10px;
  border: 1px solid #9ca3af;
  background: #ffffff;
  vertical-align: middle;
}

.categories-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
  text-align: left;
}

.email-search-bar {
  width: 85%;
  padding: 10px 14px;
  border: 1px solid #2c68ad;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s ease-in-out;
  background-color: #ffffff;
  margin-left: 40px;
  margin-bottom: 20px;
}

.search-bar:focus {
  border-color: #2c68ad;
  box-shadow: 0 0 0 3px rgba(44, 104, 173, 0.2);
  background-color: #ffffff;
}

.search-bar::placeholder {
  color: #9ca3af; /* muted gray */
  font-size: 12px;
}

.search-input-wrapper {
  position: relative;
  display: flex;
}

.search-icon {
  position: absolute;
  margin-left: 490px;
  align-items: center;
  font-size: 16px;
  color: #9ca3af;
  cursor: pointer;
  margin-top: 3px;
}

.Email-pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  gap: 10px;
  font-size: 14px;
}

.Email-pagination-btn {
  padding: 6px 14px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: not-allowed;
  background-color: #cbd5e1; /* gray when disabled */
  color: #ffffff;
  transition: background-color 0.2s ease-in-out, cursor 0.2s ease-in-out;
}

.Email-pagination-btn:not(:disabled) {
  background-color: #2c68ad; /* blue when enabled */
  cursor: pointer;
}

.Email-pagination-btn:not(:disabled):hover {
  background-color: #2c68ad; /* darker blue on hover */
}

.Email-pagination-separator {
  margin: 0 6px;
  color: #6b7280; /* gray-500 */
}

.Email-pagination-page {
  font-weight: 600;
  color: #6b7280; /* gray-700 */
}

/* --- Final overrides for Step 1 layout --- */
.categories-header-grid {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: space-between !important;
  gap: 16px !important;
  padding: 0 6px !important;
}

.categories-header-text {
  margin-top: 10px;
  flex-direction: column !important;
  align-items: flex-start !important;
  gap: 8px !important;
}

.categories-subtitle {
  display: inline-block;
  white-space: nowrap;
}

.select-all {
  margin: 0 !important;
  justify-self: auto !important;
}

.search-input-wrapper {
  position: relative !important;
}

.search-icon {
  right: 12px !important;
  left: auto !important;
  margin: 0 !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  pointer-events: none;
}

.email-search-bar {
  padding-right: 36px !important;
  padding-left: 12px !important;
  width: 100% !important;
  margin-left: 0 !important;
}

.campaign-type-step {
  background: #ffffff;
  border-radius: 12px;
  padding: 18px 22px 22px;
  box-shadow: none;
  border: 1px solid #e5e7eb;
  max-width: 520px;
  margin: 24px auto 0;
}

.disabled-btn {
  background-color: #e5e7eb !important;
  color: #9ca3af !important;
  cursor: not-allowed !important;
  opacity: 0.7;
}

.campaign-type-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
  margin-top: 6px;
  margin-bottom: 6px;
}

.custom-campaign-type-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
  margin-top: 25px;
  margin-bottom: 35px;
}

.campaign-type-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 16px;
  margin-top: 14px;
  margin-bottom: 10px;
}

.center-card {
  grid-column: 1/-1;
  justify-self: center;
  max-width: 220px;
}

.campaign-card {
  border: 1px solid rgb(117, 117, 117);
  border-radius: 6px;
  padding: 12px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #ffffff;
  width: 100%;
  text-align: center;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
}

.campaign-card:hover {
  background: #fafafa;
}

.ai-back-btn {
  border-radius: 12px;
  font-weight: 400;
  cursor: pointer;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  background: #2c68ad;
  color: #ffffff;
  border: none;
  transition: background 0.2s ease;
  /* remove forced min-width */
  min-width: auto;
  width: auto;
  height: 40px;
  /* make sure text is centered */
  text-align: center;
  display: inline-block;
}

.ai-back-btn:hover:not(:disabled) {
  background: #3079bb;
  border: none !important;
}

.ai-back-btn,
.ai-next-btn {
  min-width: 120px; /* both buttons same width */
  padding: 10px 20px;
}

@media (max-width: 768px) {
  .step-nav,
  .step-nav--categories,
  .step-nav--campaign {
    max-width: 100%;
  }
  .step-nav--with-back {
    justify-content: space-between;
  }
}
.ai-back-btn:disabled {
  background: #9ca3af;
  color: #ffffff;
  cursor: not-allowed;
}

.campaign-card.selected {
  background-color: rgba(44, 104, 173, 0.18);
  border-color: #2c68ad;
}

.campaign-card.selected .card-title,
.campaign-card.selected .card-desc {
  color: #000000;
}

.card-title {
  font-weight: 600;
  margin-bottom: 0;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  white-space: normal;
}

.card-desc {
  font-size: 10px;
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  line-height: 1.25;
  text-align: center;
  margin: 0;
}

.ai-prompt-step {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px 32px;
  max-width: 1000px;
  margin: 0 auto;
  margin-top: -30px;
  margin-bottom: 40px;
}

.loading-spinner {
  margin-left: 8px;
}

.prompt-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  margin-top: 20px;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
}

.prompt-subtitle {
  font-size: 12px;
  color: #1a1a1a;
  margin-bottom: 12px;
  font-weight: 400;
  font-family: "Open Sans", sans-serif;
}

.tone-title {
  font-size: 12px;
  color: #1a1a1a;
  margin-bottom: 12px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
}

.prompt-textarea {
  width: 100%;
  min-height: 80px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px;
  font-size: 14px;
  margin-bottom: 20px;
}

.tone-section {
  margin-bottom: 20px;
}

.tone-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.tone-btn {
  border: 1px solid rgb(117, 117, 117);
  border-radius: 8px;
  padding: 6px 14px;
  background: #ffffff;
  cursor: pointer;
  font-size: 14px;
}

.tone-btn:hover {
  background: #fafafa;
}

.tone-btn.active {
  background-color: rgba(44, 104, 173, 0.18);
  border-color: #2c68ad;
}

.prompt-input {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  margin-bottom: 12px;
}

.form-section {
  margin-bottom: 16px;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #1a1a1a;
}

.prompt-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 10px;
  color: #1a1a1a;
  font-weight: 600;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
}

.form-label-cta {
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #1a1a1a;
  margin-left: 420px;
  font-family: "Open Sans", sans-serif;
}

.cta-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cta-labels-row {
  display: flex;
  gap: 24px;
  justify-content: flex-start;
}

.cta-labels-row .form-label {
  min-width: 120px;
  text-align: left;
}

.cta-inputs-row {
  display: flex;
  gap: 24px;
}

.cta-input-offer {
  flex: 0 0 12%; /* small fixed size */
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  height: 40px; /* consistent */
}

.cta-input-link {
  flex: 1 1; /* takes full remaining space */
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  height: 40px;
}

.cta-input-label {
  flex: 0 0 25%; /* medium width */
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  height: 40px;
  color: #1a1a1a;
}

.cta-group {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.generate-actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.generate-btn {
  width: auto;
  padding: 10px 16px;
  background: #2c68ad;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
  text-align: center;
}

.generate-spinner {
  display: inline-flex;
  align-items: center;
}

/* step 5 */
.review-step {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.campaign-summary-box {
  background: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 24px;
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #1a1a1a;
}

.summary-content {
  display: flex;
  flex-direction: column;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px 24px;
  margin-bottom: 24px;
  margin-right: 450px;
}

.summary-input-wrapper {
  display: flex;
  align-items: center;
  position: relative;
}

.summary-item label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
}

.input-with-icon-container {
  position: relative;
  display: flex;
  align-items: center;
}

.edit-icon.inside-input {
  position: absolute;
  right: 8px;
  cursor: pointer;
  color: #6b7280;
  font-size: 14px;
  margin-right: 20px;
}

.edit-icon.inside-input:hover {
  color: #1a1a1a;
}

.edit-icon-Manual {
  position: absolute;
  right: 8px;
  cursor: pointer;
  color: #6b7280;
  font-size: 14px;
}

.form-input-summary {
  width: 100%;
  max-width: 100%;
  padding-right: 34px !important;
}

.form-input-summary[readonly] {
  background-color: #fafafa;
  border: 1px solid #e5e7eb;
  cursor: not-allowed;
}

.edit-icon {
  margin-left: 8px;
  font-size: 16px;
  color: #1a1a1a;
  cursor: pointer;
  transition: color 0.2s ease;
}

.edit-icon:hover {
  color: #1a1a1a;
}

.form-input:focus {
  outline: none;
  border-color: #2c68ad;
  box-shadow: 0 0 0 2px rgba(44, 104, 173, 0.2);
}

.datetime-container {
  display: flex;
  justify-content: flex-end;
}

.datetime-row {
  display: flex;
  align-items: flex-end;
  gap: 30px;
  width: 66.66%;
  margin-left: 730px;
  margin-bottom: 80px;
  margin-top: -60px;
}

.email-editor-campaign {
  max-width: 900px;
}

.campaign-summary-heading {
  color: #1a1a1a;
  font-size: 20px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  margin-left: 35px;
}

.Email-footer-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}

.date-input-group,
.time-input-group {
  display: flex;
  flex-direction: column;
}

.date-input-group label,
.time-input-group label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #6b7280;
}

.date-range-inputs {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 70%; /* take full row */
}

.date-range-inputs .ant-picker {
  flex: 1 1;
  min-width: 250px;
  height: 3rem;
  font-size: 14px;
  padding: 0 0.75rem;
}

.date-input {
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 10px;
  font-size: 14px;
  min-width: 140px;
}

.date-separator {
  color: #9ca3af;
  font-size: 14px;
}

.time-input {
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 10px;
  font-size: 14px;
  min-width: 120px;
}

/* Responsive adjustments */
@media (max-width: 900px) {
  .datetime-row {
    width: 100%;
    justify-content: flex-start;
  }
}
@media (max-width: 768px) {
  .summary-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .datetime-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    width: 100%;
  }
}
@media (max-width: 480px) {
  .summary-grid {
    grid-template-columns: 1fr;
  }
  .date-range-inputs {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .date-separator {
    align-self: center;
  }
}
.ai-error-toast {
  position: fixed;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
  background: #ffffff;
  color: #1a1a1a;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  padding: 10px 12px;
  display: flex;
  align-items: center;
  min-width: 340px;
  max-width: 90vw;
  font-size: 12px;
  font-weight: 400;
  border: none;
  animation: fadeIn 0.3s;
}

.ai-error-toast .error-icon {
  background: #e53935;
  color: #ffffff;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-right: 16px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px) translateX(-50%);
  }
  to {
    opacity: 1;
    transform: translateY(0) translateX(-50%);
  }
}
.Manual-summary-box {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}

.manual-review-step {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  max-width: 1300px;
  margin: 0 auto;
}

.review-send-page {
  width: 100%;
}

.review-send-page .review-send-shell {
  padding: 40px;
}

.review-send-page .review-send-title-row {
  margin-bottom: 20px !important;
}

.review-send-page .form-title,
.review-send-page .review-summary-heading {
  margin: 0;
}

.review-send-page .review-step {
  padding: 0;
  max-width: 1200px;
  width: 100%;
}

.review-send-page .Manual-summary-box {
  box-shadow: none;
}

.review-send-page .summary-grid {
  grid-template-columns: repeat(3, minmax(220px, 1fr));
  gap: 24px 48px;
  margin-left: 0;
  margin-right: 0;
}

@media (max-width: 768px) {
  .review-send-page .review-send-shell {
    padding: 24px;
  }
  .review-send-page .summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
  }
}
@media (max-width: 480px) {
  .review-send-page {
    padding: 12px;
  }
  .review-send-page .review-send-shell,
  .review-send-page .Manual-summary-box {
    padding: 16px;
  }
  .review-send-page .summary-grid {
    grid-template-columns: 1fr;
  }
}
.custom-label {
  display: block;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
  margin-top: 20px;
}

.custom-campaign-form {
  padding-bottom: 40px;
  max-width: 500px;
  margin: 0 auto;
}

/* =========================================
   📱 MOBILE (max-width: 468px)
   ========================================= */
@media (max-width: 468px) {
  .ai-email-editor-container {
    padding: 10px;
    margin-top: 10px;
  }
  .page-header {
    flex-direction: row;
    font-size: 12px;
    gap: 8px;
    align-items: center;
  }
  .Page-header-text {
    font-size: 10px;
    line-height: 1.4;
  }
  .email-editor-content {
    flex-direction: column;
    gap: 20px;
    padding: 10px;
  }
  .left-panel,
  .right-panel {
    width: 100%;
  }
  .form-section {
    margin: 0;
  }
  .form-title {
    font-size: 20px;
    margin-bottom: 15px;
  }
  .form-label {
    font-size: 12px;
  }
  .form-input,
  .form-textarea {
    width: 100%;
    font-size: 14px;
  }
  .form-textarea {
    height: 120px;
  }
  .ai-generator-toggle {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 10px 0;
  }
  .toggle-switch {
    align-self: flex-end;
  }
  .preview-section {
    margin-top: 20px;
  }
  .footer-actions {
    flex-direction: column-reverse;
    gap: 10px;
    margin-top: 20px;
    align-items: stretch;
  }
  .cancel-btn,
  .next-btn {
    width: 100%;
    min-width: unset;
    font-size: 16px;
    padding: 12px;
  }
}
/* =========================================
   💻 TABLET (max-width: 786px)
   ========================================= */
@media (max-width: 786px) {
  .ai-email-editor-container {
    padding: 20px;
  }
  .email-editor-content {
    flex-direction: column;
    gap: 25px;
  }
  .left-panel,
  .right-panel {
    width: 100%;
  }
  .form-section {
    margin: 0;
  }
  .form-title {
    font-size: 20px;
  }
  .form-input,
  .form-textarea {
    width: 100%;
  }
  .ai-generator-toggle {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .footer-actions {
    justify-content: center;
    gap: 15px;
    margin-top: 30px;
  }
  .cancel-btn,
  .next-btn {
    min-width: 140px;
    font-size: 16px;
  }
}
.schedule-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(26, 26, 26, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.schedule-modal {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.25s ease-in-out;
}

.schedule-picker-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #1a1a1a;
}

.schedule-picker-paragraph {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 16px;
}

.schedule-picker-presets {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.preset-button {
  background: #fafafa;
  border: 1px solid #cbd5e1;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}
.preset-button:hover {
  background: #e5e7eb;
}

.schedule-label {
  font-size: 14px;
  color: #6b7280;
  display: block;
  margin-bottom: 6px;
}

.schedule-input {
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  margin-bottom: 12px;
  transition: border-color 0.2s ease;
}
.schedule-input:focus {
  border-color: #2c68ad;
  outline: none;
}

.schedule-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

/* --- Final layout fixes for step 1 header/search --- */
.page-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 0 20px;
  padding: 0 8px;
  margin-top: 10px;
}

.back-button--text {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background: #2c68ad;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.back-button--text:hover {
  background: #3079bb;
}

.Page-header-text {
  font-size: 12px;
  font-weight: 400;
  color: #6b7280;
  text-align: center;
  margin-top: 10px;
  max-width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.progress-header {
  width: 100%;
  margin: 10px 0 28px;
  margin-left: 0;
}

.progress-top {
  padding: 0 2px;
}

.progress-step {
  margin-right: 0;
}

.progress-track {
  width: 100%;
}

.categories-header-grid {
  align-items: flex-start !important;
}

.select-all {
  margin-top: 2px !important;
}

.categories-search {
  margin: 10px 0 14px;
}

.categories-search-input.styled-input.ant-input-affix-wrapper {
  width: 100%;
  height: 40px;
}

.categories-search-input .ant-input {
  padding-right: 30px;
}

.categories-search-input .ant-input-prefix {
  display: inline-flex;
  align-items: center;
  color: #6b7280;
  margin-right: 8px;
}

.categories-search-input .ant-input-suffix {
  display: none !important;
}

.categories-search-icon {
  font-size: 16px;
  color: #6b7280;
}

@media (max-width: 468px) {
  .page-header {
    padding: 0 6px;
  }
  .Page-header-text {
    max-width: 60%;
    font-size: 10px;
  }
  .back-button--text {
    padding: 4px 10px;
  }
}
.proceed-button {
  flex: 1 1;
  background: #2c68ad;
  color: #ffffff;
  border: none;
  padding: 10px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}
.proceed-button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}
.proceed-button:hover:not(:disabled) {
  background: #3079bb;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/Engagements/Campaigns/AIEmailEditor/AIEmailEditor.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACG,iBAAA;EACH,gBAAA;AAAA;;AAEA;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACI,iBAAA;AACN;;AACA;EACI,mBCFI;EDGN,aAAA;EACA,kBCgMU;ED/LV,iBAAA;EACA,YAAA;AAEF;;AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAGF;;AAAA;EACE,eC6La;ED5Lb,gBCiMqB;EDhMrB,cCXe;EDYf,oCCwLY;ADrLd;;AAAA;EACE,eCsLa;EDrLb,gBC0LqB;EDzLrB,cClBe;EDmBf,oCCiLY;EDhLZ,kBAAA;AAGF;;AAAA;EACE,UAAA;EACA,YAAA;EACA,mBCpBa;EDqBb,kBCmKU;EDlKV,gBAAA;AAGF;;AAAA;EACE,YAAA;EACA,mBClDc;EDmDd,2BAAA;AAGF;;AACA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBChDM;EDiDN,yBAAA;EACA,mBCmJU;EDlJV,kBAAA;EACA,yCC6HU;ED5HV,kBAAA;EACE,mBAAA;EACI,iBAAA;EACA,gBAAA;EACI,mBAAA;AAEZ;AAAE;EACE,mBAAA;AAEJ;AAAI;EACE,WAAA;EACA,YAAA;AAEN;AAEE;EACE,eC0IW;EDzIX,gBC2ImB;ED1InB,kBAAA;EACA,cCnEW;EDoEX,oCCiIU;ADjId;AAGE;EACE,eC+HW;ED9HX,cCxEa;EDyEb,mBAAA;EACA,gBCiImB;EDhInB,oCCyHU;AD1Hd;AAIE;EACE,cAAA;EACA,gBAAA;EACA,eCqHW;EDpHX,gBCyHmB;EDxHnB,kBAAA;EACA,cCpFa;EDqFb,oCC+GU;ADjHd;AAKE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBCkGQ;EDjGR,eC0GW;EDzGX,eAAA;EACA,aAAA;AAHJ;AAKI;EACE,qBCnHU;EDoHV,6CAAA;AAHN;AAOE;EACE,eC8FW;ED7FX,cCzGa;ED0Gb,kBAAA;EACA,gBAAA;EACA,gBC+FmB;ED9FnB,oCCuFU;EDtFV,mBAAA;AALJ;AAQE;EACE,UAAA;EACA,kBAAA;EACA,mBCpIkB;EDqIlB,cCnHW;EDoHX,YAAA;EACA,kBCuEQ;EDtER,eCgFW;ED/EX,gBCkFmB;EDjFnB,eAAA;EACA,gCAAA;EACA,oCCwEU;EDvEV,kCAAA;AANJ;AAQI;EACE,mBC/IiB;ADyIvB;;AAUA;EACI,cCrIa;EDsIb,eCiEW;EDhEX,gBCoEmB;EDnEnB,oCC4DU;ADnEd;;AASA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,8BAAA;AANF;;AASA;EACE,kBAAA;EACA,kBC6BU;ED5BV,gBCyCqB;EDxCrB,eAAA;EACA,gBAAA,EAAA,6BAAA;EACA,kBAAA;EACA,eCkCa;EDjCb,oCC6BY;ED5BZ,oCAAA;EACA,yBAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;AANF;;AASA,mBAAA;AACA;EACE,mBCzKY;ED0KZ,cChLa;EDiLb,mBAAA;AANF;;AASA,+BAAA;AACA;EACE,aAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AANF;;AASA;EACE,mBCtMM;EDuMN,mBCFU;EDGV,kBAAA;EACA,yCCxBU;EDyBV,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AANF;;AASA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AANF;;AASA;EACE,eCnBa;EDoBb,gBCjBqB;EDkBrB,cC9Na;ED+Nb,oCC1BY;ED2BZ,SAAA;AANF;;AASA;EACE,eC7Ba;ED8Bb,gBAAA;EACA,cCrOe;EDsOf,SAAA;EACA,oCCnCY;AD6Bd;;AASA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eCxCa;EDyCb,gBCpCqB;EDqCrB,oCC5CY;ED6CZ,cClPa;EDmPb,eAAA;EACA,eAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,qBC1Qc;ED2Qd,SAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,kBAAA;AANF;;AASA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,cCzQW;ED0QX,eAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBCrFU;EDsFV,eC9Ea;ED+Eb,aAAA;EACA,gCAAA;EACA,yBC7RM;ADuRR;;AASA;EACE,cC1RW;ED2RX,eCtFa;ADgFf;;AASA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;EACA,sBAAA;AANF;;AASA;EACE,iBAAA;EACA,yBAAA;EACA,kBC3GU;ED4GV,eCpGa;EDqGb,gBChGqB;EDiGrB,kBAAA;EACA,eAAA;EACA,yBCpTM;EDqTN,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cCpTa;EDqTb,oCChHY;AD0Gd;;AASA;EACE,yBC7TmB;ADuTrB;;AASA;EACE,0CC1UoB;ED2UpB,cC9Ta;ED+Tb,yBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AANF;;AASA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AANJ;;AASA;EACE,YAAA;EACA,mBAAA;AANF;;AASA;EACE,eCrJa;EDsJb,gBCjJqB;EDkJrB,cC9Va;ADwVf;;AASA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AANF;AAQE;EACE,iBAAA;EACA,kBC1KQ;ED2KR,yBAAA;EACA,mBChXI;EDiXJ,eAAA;EACA,gBAAA;AANJ;AAQI;EACE,mBCnXa;AD6WnB;AASI;EACE,YAAA;EACA,mBAAA;AAPN;;AAWA;EACE,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AARF;;AAWA;EACE,eC3La;ED4Lb,gBCxLqB;EDyLnB,oCChMU;EDiMZ,cCrYe;EDsYf,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;AARF;;AAUA;EACI,WAAA;EACA,YAAA;AAPJ;;AASA;EACE,oBAAA;EACA,mBAAA;EACA,eC3Ma;ED4Mb,gBCxMqB;EDyMrB,oCChNY;EDiNZ,cCtZa;EDuZb,QAAA;EACA,eAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,qBC9ac;ED+ad,SAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBCxaM;EDyaN,sBAAA;AANF;;AASA;EACE,eC9Na;ED+Nb,gBC7NqB;ED8NrB,cC1aa;ED2ab,oCCtOY;EDuOZ,gBAAA;AANF;;AASA;EACE,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBCpPU;EDqPV,eC5Oa;ED6Ob,aAAA;EACA,gCAAA;EACA,yBC5bM;ED6bR,iBAAA;EACE,mBAAA;AANF;;AASA;EACE,qBC7cc;ED8cd,6CAAA;EACA,yBCpcM;AD8bR;;AASA;EACE,cCjcW,EDicS,eAAA;EACpB,eC7Pa;ADuPf;;AASA;EACE,kBAAA;EACA,aAAA;AANF;;AASA;EACE,kBAAA;EACD,kBAAA;EACA,mBAAA;EACC,eCvQa;EDwQb,cC/cW;EDgdX,eAAA;EACA,eAAA;AANF;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,eCrRa;AD8Qf;;AAUA;EACE,iBAAA;EACA,YAAA;EACA,kBCpSU;EDqSV,eC5Ra;ED6Rb,gBCzRqB;ED0RrB,mBAAA;EACA,yBC/de,ED+doB,uBAAA;EACnC,cCrea;EDseb,sEAAA;AAPF;;AAUA;EACE,yBC7fc,ED6foB,sBAAA;EAClC,eAAA;AAPF;;AAUA;EACE,yBClgBc,EDkgBoB,yBAAA;AAPpC;;AAUA;EACE,aAAA;EACA,cCtfe,EDsfS,aAAA;AAP1B;;AAUA;EACE,gBC/SqB;EDgTrB,cC3fe,ED2fS,aAAA;AAP1B;;AAUA,8CAAA;AACA;EACE,wBAAA;EACA,kCAAA;EACA,yCAAA;EACA,oBAAA;EACA,yBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,iCAAA;EACA,kCAAA;EACA,mBAAA;AAPF;;AAUA;EACE,qBAAA;EACA,mBAAA;AAPF;;AAUA;EACE,oBAAA;EACA,6BAAA;AAPF;;AAUA;EACE,6BAAA;AAPF;;AAUA;EACE,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sCAAA;EACA,oBAAA;AAPF;;AAUA;EACE,8BAAA;EACA,6BAAA;EACA,sBAAA;EACA,yBAAA;AAPF;;AAWA;EACE,mBCpjBM;EDqjBN,mBChXU;EDiXV,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AARF;;AAUA;EACE,oCAAA;EACA,yBAAA;EACA,8BAAA;EACA,YAAA;AAPF;;AAUA;EACE,eCtXa;EDuXb,gBCpXqB;EDqXrB,cCjkBa;EDkkBb,oCC7XY;ED8XZ,eAAA;EACA,kBAAA;AAPF;;AASA;EACG,eC7XY;ED8Xb,gBC5XqB;ED6XrB,cCzkBa;ED0kBb,oCCrYY;EDsYZ,gBAAA;EACA,mBAAA;AANF;;AAQA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AALF;;AAOA;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;AAJF;;AAMA;EACI,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,QAAA;AAHJ;;AAMA;EACI,mBC/mBe;AD4mBnB;;AAKA;EACE,mBC/aU;EDgbV,gBCramB;EDsanB,eAAA;EACA,eC1aa;ED2ab,oCC9aY;ED+aZ,mBCpoBc;EDqoBd,cClnBa;EDmnBf,YAAA;EACE,gCAAA;EAEA,4BAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,qBAAA;AAHF;;AAKA;EACE,mBChpBqB;EDipBnB,uBAAA;AAFJ;;AAIA;;EAEE,gBAAA,EAAA,4BAAA;EACA,kBAAA;AADF;;AAIA;EACE;;;IAGE,eAAA;EADF;EAIA;IACE,8BAAA;EAFF;AACF;AAKA;EACI,mBC/oBU;EDgpBZ,cCtpBa;EDupBb,mBAAA;AAHF;;AAKA;EACI,0CAAA;EACA,qBAAA;AAFJ;;AAIA;;EAEI,cC9pBQ;AD6pBZ;;AAGA;EACE,gBCzdqB;ED0drB,gBAAA;EACA,cCvqBa;EDwqBb,oCCneY;EDoeZ,eClea;EDmeb,gBAAA;EACA,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eC1ea;ED2eb,cChrBe;EDirBf,oCC7eY;ED8eZ,gBCxemB;EDyenB,iBAAA;EACA,kBAAA;EACA,SAAA;AAAF;;AAKA;EACE,mBCjsBM;EDksBN,mBC7fU;ED8fV,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAFF;;AAIA;EACE,gBAAA;AADF;;AAGA;EACE,eC9fa;ED+fb,gBC7fqB;ED8frB,kBAAA;EACA,gBAAA;EACA,cC5sBa;ED6sBb,oCCxgBY;ADwgBd;;AAGA;EACE,eC1gBa;ED2gBb,cCltBa;EDmtBb,mBAAA;EACA,gBCzgBmB;ED0gBnB,oCChhBY;ADghBd;;AAEA;EACI,eCjhBW;EDkhBb,cCztBa;ED0tBb,mBAAA;EACA,gBC/gBqB;EDghBrB,oCCvhBY;ADwhBd;;AACA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBCniBU;EDoiBV,aAAA;EACA,eC5hBa;ED6hBb,mBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAEF;;AACA;EACE,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBC3vBM;ED4vBN,eAAA;EACA,eChjBa;ADkjBf;;AACA;EACE,mBC/vBiB;ADiwBnB;;AACA;EACI,0CAAA;EACA,qBAAA;AAEJ;;AACA;EACE,WAAA;EACA,yBAAA;EACA,kBCxkBU;EDykBV,iBAAA;EACA,eCjkBa;EDkkBb,mBAAA;AAEF;;AAAA;EACE,mBAAA;AAGF;;AAAA;EACE,cAAA;EACA,eC1kBa;ED2kBb,gBCvkBqB;EDwkBrB,kBAAA;EACA,cCrxBa;ADwxBf;;AAAA;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBC7lBU;ED8lBV,eCvlBa;EDwlBb,cC9xBa;ED+xBb,gBCnlBqB;ADslBvB;;AADA;EACE,cAAA;EACA,eC3lBa;ED4lBb,gBCxlBqB;EDylBrB,kBAAA;EACA,cCtyBa;EDuyBb,oCClmBY;ADsmBd;;AAFA;EACE,cAAA;EACA,eCnmBa;EDomBb,gBChmBqB;EDimBrB,kBAAA;EACA,cC9yBa;ED+yBb,kBAAA;EACA,oCC3mBY;ADgnBd;;AAHA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAMF;;AAHA;EACE,aAAA;EACA,SAAA;EACA,2BAAA;AAMF;;AAHA;EACE,gBAAA;EACA,gBAAA;AAMF;;AAHA;EACE,aAAA;EACA,SAAA;AAMF;;AAHA;EACE,aAAA,EAAA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBC7oBU;ED8oBV,eCroBa;EDsoBb,YAAA,EAAA,eAAA;AAMF;;AAHA;EACE,SAAA,EAAA,+BAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBCtpBU;EDupBV,eC9oBa;ED+oBb,YAAA;AAMF;;AAHA;EACE,aAAA,EAAA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBC/pBU;EDgqBV,eCvpBa;EDwpBb,YAAA;EACA,cCj2Ba;ADu2Bf;;AAHA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAMF;;AAHA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAMF;;AAHA;EACE,WAAA;EACA,kBAAA;EACA,mBCr4Bc;EDs4Bd,cCn3Ba;EDo3Bb,gBC3qBqB;ED4qBrB,eChrBa;EDirBb,YAAA;EACA,kBC3rBU;ED4rBV,eAAA;EACA,2BAAA;EACA,kBAAA;AAMF;;AAHA;EACE,oBAAA;EACA,mBAAA;AAMF;;AAHA,WAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AAMF;;AAHA;EACE,mBCr5BM;EDs5BN,YAAA;EACA,kBCntBU;EDotBV,aAAA;AAMF;;AAHA;EACE,eC7sBa;ED8sBb,gBC5sBqB;ED6sBrB,mBAAA;EACA,cC15Ba;ADg6Bf;;AAHA;EACE,aAAA;EACA,sBAAA;AAMF;;AAHA;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAMF;;AAJA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAOF;;AALA;EACE,cAAA;EACA,eCxuBa;EDyuBb,gBCruBqB;EDuuBrB,cCn7Ba;EDo7Bb,oCC/uBY;ADsvBd;;AAJA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAOF;;AAJA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,cCh8Be;EDi8Bf,eC1vBa;ED2vBT,kBAAA;AAON;;AAJA;EACE,cCv8Ba;AD88Bf;;AALA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,cC58Be;ED68Bf,eCtwBa;AD8wBf;;AALA;EACE,WAAA;EACA,eAAA;EACA,8BAAA;AAQF;;AANA;EACE,yBC19BiB;ED29BjB,yBAAA;EACA,mBAAA;AASF;;AANA;EACE,gBAAA;EACA,eCrxBa;EDsxBb,cC/9Ba;EDg+Bb,eAAA;EACA,2BAAA;AASF;;AANA;EACE,cCr+Ba;AD8+Bf;;AAPA;EACE,aAAA;EACA,qBCz/Bc;ED0/Bd,6CAAA;AAUF;;AAPA;EACE,aAAA;EACA,yBAAA;AAUF;;AAPA;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,aAAA;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;AAUN;;AARA;EACE,gBAAA;AAWF;;AATA;EACE,cC//Ba;EDggCb,eCtzBa;EDuzBb,gBCrzBqB;EDszBrB,oCC7zBY;ED8zBZ,iBAAA;AAYF;;AAVA;EACI,aAAA;EACF,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAaF;;AAXA;;EAEE,aAAA;EACA,sBAAA;AAcF;;AAXA;;EAEE,eC50Ba;ED60Bb,gBCz0BqB;ED00BrB,kBAAA;EACA,cCthCe;ADoiCjB;;AAXA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA,EAAA,kBAAA;AAcF;;AAXA;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,eC71Ba;ED81Bb,kBAAA;AAcF;;AAXA;EACE,yBAAA;EACA,kBC52BU;ED62BV,aAAA;EACA,eCr2Ba;EDs2Bb,gBAAA;AAcF;;AAXA;EACE,cChjCW;EDijCX,eC32Ba;ADy3Bf;;AAXA;EACE,yBAAA;EACA,kBCz3BU;ED03BV,aAAA;EACA,eCl3Ba;EDm3Bb,gBAAA;AAcF;;AAXA,2BAAA;AACA;EACE;IACE,WAAA;IACA,2BAAA;EAcF;AACF;AAXA;EACE;IACE,qCAAA;EAaF;EAVA;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,WAAA;EAYF;AACF;AATA;EACE;IACE,0BAAA;EAWF;EARA;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EAUF;EAPA;IACE,kBAAA;EASF;AACF;AALA;EACE,eAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,mBC/mCM;EDgnCN,cC3mCa;ED4mCb,mBC56BU;ED66BV,yCCj8BU;EDk8BV,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,eC56Ba;ED66Bb,gBCz6BmB;ED06BnB,YAAA;EACA,sBAAA;AAOF;;AAJA;EACE,mBC9mCO;ED+mCP,cCxnCa;EDynCb,kBC17Ba;ED27Bb,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eCx7Ba;EDy7Bb,kBAAA;AAOF;;AAJA;EACE;IAAO,UAAA;IAAY,6CAAA;EASnB;EARA;IAAK,UAAA;IAAY,yCAAA;EAYjB;AACF;AAVA;EACE,mBCjpCM;EDkpCN,yBAAA;EACA,kBC/8BU;EDg9BV,aAAA;EACA,yCCp+BU;ADg/BZ;;AAVA;EACG,aAAA;EACD,sBAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AAaF;;AAVA;EACE,WAAA;AAaF;;AAVA;EACE,aAAA;AAaF;;AAVA;EACE,8BAAA;AAaF;;AAVA;;EAEE,SAAA;AAaF;;AAVA;EACE,UAAA;EACA,iBAAA;EACA,WAAA;AAaF;;AAVA;EACE,gBAAA;AAaF;;AAVA;EACE,oDAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAaF;;AAVA;EACE;IACE,aAAA;EAaF;EAVA;IACE,gDAAA;IACA,SAAA;EAYF;AACF;AATA;EACE;IACE,aAAA;EAWF;EARA;;IAEE,aAAA;EAUF;EAPA;IACE,0BAAA;EASF;AACF;AANA;EACE,cAAA;EACA,eChhCa;EDihCb,gBC9gCqB;ED+gCrB,kBAAA;EACA,cC5tCa;ED6tCb,oCCxhCY;EDyhCZ,gBAAA;AAQF;;AANA;EACI,oBAAA;EACF,gBAAA;EACA,cAAA;AASF;;AANA;;8CAAA;AAGA;EACE;IACE,aAAA;IACA,gBAAA;EASF;EANA;IACE,mBAAA;IACA,eC1iCW;ID2iCX,QAAA;IACA,mBAAA;EAQF;EALA;IACE,eCjjCW;IDkjCX,gBAAA;EAOF;EAJA;IACE,sBAAA;IACA,SAAA;IACA,aAAA;EAMF;EAHA;;IAEE,WAAA;EAKF;EAFA;IACE,SAAA;EAIF;EADA;IACE,eCjkCW;IDkkCX,mBAAA;EAGF;EAAA;IACE,eCzkCW;ED2kCb;EACA;;IAEE,WAAA;IACA,eC9kCW;ED+kCb;EAEA;IACE,aAAA;EAAF;EAGA;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,eAAA;EADF;EAIA;IACE,oBAAA;EAFF;EAKA;IACE,gBAAA;EAHF;EAMA;IACE,8BAAA;IACA,SAAA;IACA,gBAAA;IACA,oBAAA;EAJF;EAOA;;IAEE,WAAA;IACA,gBAAA;IACA,eC9mCW;ID+mCX,aAAA;EALF;AACF;AAQA;;8CAAA;AAGA;EACE;IACE,aAAA;EANF;EASA;IACE,sBAAA;IACA,SAAA;EAPF;EAUA;;IAEE,WAAA;EARF;EAWA;IACE,SAAA;EATF;EAYA;IACE,eCzoCW;ED+nCb;EAaA;;IAEE,WAAA;EAXF;EAcA;IACE,mBAAA;IACA,8BAAA;IACA,mBAAA;EAZF;EAeA;IACE,uBAAA;IACA,SAAA;IACA,gBAAA;EAbF;EAgBA;;IAEE,gBAAA;IACA,eCjqCW;EDmpCb;AACF;AAgBA;EACE,eAAA;EACA,QAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAdF;;AAiBA;EACE,mBC73CM;ED83CN,mBCzrCU;ED0rCV,aAAA;EACA,WAAA;EACA,gBAAA;EACA,yCChtCU;EDitCV,mCAAA;AAdF;;AAiBA;EACE,eCxrCa;EDyrCb,gBCvrCqB;EDwrCrB,kBAAA;EACA,cCr4Ca;ADu3Cf;;AAiBA;EACE,eCjsCa;EDksCb,cCz4Ce;ED04Cf,mBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,mBCz5CiB;ED05CjB,yBAAA;EACA,kBAAA;EACA,kBC1tCU;ED2tCV,eAAA;EACA,yBAAA;EACA,gBAAA;AAdF;AAgBE;EACE,mBCx5CW;AD04Cf;;AAkBA;EACE,eC5tCa;ED6tCb,cCp6Ce;EDq6Cf,cAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,WAAA;EACA,aAAA;EACA,kBC9uCU;ED+uCV,yBAAA;EACA,mBAAA;EACA,kCAAA;AAfF;AAiBE;EACE,qBCn8CY;EDo8CZ,aAAA;AAfJ;;AAmBA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAhBF;;AAmBA,wDAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,mBC/9Cc;EDg+Cd,cC78Ca;ED88Cb,YAAA;EACA,kBCnxCU;EDoxCV,iBAAA;EACA,eC7wCa;ED8wCb,gBCzwCqB;ED0wCrB,eAAA;AAhBF;;AAmBA;EACE,mBCx+CqB;ADw9CvB;;AAmBA;EACE,eCvxCa;EDwxCb,gBCpxCmB;EDqxCnB,cC/9Ce;EDg+Cf,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAhBF;;AAmBA;EACE,WAAA;EACA,mBAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,cAAA;AAhBF;;AAmBA;EACE,eAAA;AAhBF;;AAmBA;EACE,WAAA;AAhBF;;AAmBA;EACE,kCAAA;AAhBF;;AAmBA;EACE,0BAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,WAAA;EACA,YAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,oBAAA;EACA,mBAAA;EACA,cClhDe;EDmhDf,iBAAA;AAhBF;;AAmBA;EACE,wBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,cC5hDe;AD4gDjB;;AAmBA;EACE;IACE,cAAA;EAhBF;EAmBA;IACE,cAAA;IACA,eCj2CW;EDg1Cb;EAoBA;IACE,iBAAA;EAlBF;AACF;AAqBA;EACE,SAAA;EACA,mBCjkDc;EDkkDd,cC/iDa;EDgjDb,YAAA;EACA,aAAA;EACA,mBCr3CU;EDs3CV,gBC12CqB;ED22CrB,eAAA;EACA,gCAAA;AAnBF;AAqBE;EACE,mBCzjDS;ED0jDT,mBAAA;AAnBJ;AAsBE;EACE,mBC9kDmB;AD0jDvB;;AAwBA;EACE;IAAO,UAAA;IAAY,sBAAA;EAnBnB;EAoBA;IAAK,UAAA;IAAY,mBAAA;EAhBjB;AACF","sourcesContent":["@import '../../../../styles/variables';\n\n.ai-email-campaign-container{\n   min-height: 100vh;\nmargin-top: 20px;\n}\n.progress-header {\n  width: 100%;\n  margin: 16px 0;\n  display: flex;\n  flex-direction: column; \n  gap: 6px;\n      margin-left: 35px;\n}\n.ai-email-campaign-setup{\n    background: $white;\n  padding: 40px;\n  border-radius: $radius-md;\n  max-width: 1300px;\n  margin: auto;\n}\n.progress-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.progress-title {\n  font-size: $font-size-sm;\n  font-weight: $font-weight-semibold;\n  color: $text-secondary;\n  font-family: $font-family;\n}\n\n.progress-step {\n  font-size: $font-size-sm;\n  font-weight: $font-weight-semibold;\n  color: $text-secondary;\n  font-family: $font-family;\n  margin-right: 80px;\n}\n\n.progress-track {\n  width: 94%;\n  height: 15px;\n  background: $border-light;\n  border-radius: $radius-md;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: $brand-primary; \n  transition: width 0.3s ease;\n}\n\n\n.setup-box {\n  max-width: 600px;\n  margin: 24px auto;\n  padding: 32px 24px;\n  background: $white;\n  border: 1px solid $border-light;\n  border-radius: $radius-lg;\n  text-align: center;\n  box-shadow: $shadow-md;\n  padding-left: 50px;\n    padding-right: 30px;\n        padding-top: 40px;\n        margin-top: 70px;\n            margin-bottom: 70px;\n\n  &__icon {\n    margin-bottom: 16px;\n\n    img {\n      width: 56px;\n      height: 56px;\n    }\n  }\n\n  &__title {\n    font-size: $font-size-xl;\n    font-weight: $font-weight-semibold;\n    margin-bottom: 8px;\n    color: $text-primary;\n    font-family: $font-family;\n  }\n\n  &__subtitle {\n    font-size: $font-size-sm;\n    color: $text-secondary;\n    margin-bottom: 24px;\n    font-weight: $font-weight-semibold;\n    font-family: $font-family;\n  }\n\n  &__label {\n    display: block;\n    text-align: left;\n    font-size: $font-size-sm;\n    font-weight: $font-weight-semibold;\n    margin-bottom: 8px;\n    color: $text-secondary;\n    font-family: $font-family;\n  }\n\n  &__input {\n    width: 100%;\n    padding: 10px 14px;\n    border: 1px solid $border-default;\n    border-radius: $radius-md;\n    font-size: $font-size-md;\n    margin-top: 6px;\n    outline: none;\n\n    &:focus {\n      border-color: $brand-primary;\n      box-shadow: 0 0 0 2px rgba($brand-primary, 0.2);\n    }\n  }\n\n  &__hint {\n    font-size: $font-size-sm;\n    color: $text-secondary;\n    margin: 8px 0 16px;\n    text-align: left;\n    font-weight: $font-weight-semibold;\n    font-family: $font-family;\n    margin-bottom: 25px;\n  }\n\n  &__button {\n    width: 70%;\n    padding: 12px 16px;\n    background: $brand-primary-hover;\n    color: $text-inverse;\n    border: none;\n    border-radius: $radius-md;\n    font-size: $font-size-lg;\n    font-weight: $font-weight-semibold;\n    cursor: pointer;\n    transition: background 0.2s ease;\n    font-family: $font-family;\n    justify-content: center !important;\n\n    &:hover {\n      background: $brand-primary-strong;\n    }\n  }\n}\n.setup_text{\n    color: $text-secondary;\n    font-size: $font-size-md;\n    font-weight: $font-weight-semibold;\n    font-family: $font-family;\n}\n.step-nav {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  margin: 20px auto 0;\n}\n\n.step-nav--categories {\n  max-width: 620px;\n}\n\n.step-nav--campaign {\n  max-width: 520px;\n}\n\n.step-nav--with-back {\n  justify-content: space-between;\n}\n\n.ai-next-btn {\n  padding: 10px 20px;\n  border-radius: $radius-md;\n  font-weight: $font-weight-semibold;\n  cursor: pointer;\n  min-width: 150px; /* keep uniform button size */\n  text-align: center;\n  font-size: $font-size-lg;\n  font-family: $font-family;\n  background-color: $brand-primary !important;\n  color: $text-inverse !important;\n  border: none;\n  transition: background 0.2s ease;\n  margin-bottom: 0;\n}\n\n/* Disabled state */\n.ai-next-btn:disabled {\n  background: $border-dark; \n  color: $text-inverse;      \n  cursor: not-allowed;\n}\n\n/* --- Step 1: Categories --- */\n.categories-wrapper {\n  display: flex;\n  justify-content: center !important;\n  align-items: center;\n  min-height: 100vh;\n  margin-left: 40px;\n}\n\n.categories-step {\n  background: $white;\n  border-radius: $radius-lg;\n  padding: 22px 24px;\n  box-shadow: $shadow-md;\n  max-width: 620px;\n  width: 100%;\n  margin: 24px auto;\n  margin-top: 70px;\n  border: 1px solid $border-light;\n}\n\n.categories-header-grid {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 0 6px;\n  margin-bottom: 12px;\n}\n\n.categories-header-text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.categories-title {\n  font-size: $font-size-lg;\n  font-weight: $font-weight-semibold;\n  color: $text-primary;\n  font-family: $font-family;\n  margin: 0;\n}\n\n.categories-subtitle {\n  font-size: $font-size-sm;\n  font-weight:400;\n  color: $text-secondary;\n  margin: 0;\n  font-family: $font-family;\n}\n\n.select-all {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: $font-size-sm;\n  font-weight: $font-weight-semibold;\n  font-family: $font-family;\n  color: $text-primary;\n  cursor: pointer;\n  margin-top: 4px;\n}\n\n.select-all input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  accent-color: $brand-primary;\n  margin: 0;\n}\n\n.categories-search {\n  margin: 12px 0 10px;\n}\n\n.search-input-wrapper {\n  position: relative;\n}\n\n.search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: $text-muted;\n  font-size: 14px;\n}\n\n.email-search-bar {\n  width: 100%;\n  height: 38px;\n  padding: 0 12px 0 34px;\n  border: 1px solid $border-default;\n  border-radius: $radius-md;\n  font-size: $font-size-sm;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n  background-color: $white;\n}\n\n.email-search-bar::placeholder {\n  color: $text-muted;\n  font-size: $font-size-sm;\n}\n\n.categories-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 12px;\n  margin: 28px 42px 16px;\n}\n\n.category-item {\n  padding: 8px 12px;\n  border: 1px solid $border-default;\n  border-radius: $radius-md;\n  font-size: $font-size-sm;\n  font-weight: $font-weight-semibold;\n  text-align: center;\n  cursor: pointer;\n  background-color: $white;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: $text-primary;\n  font-family: $font-family;\n}\n\n.category-item:hover {\n  background-color: $background-default;\n}\n\n.category-item.selected {\n  background-color: $brand-primary-light;\n  color: $text-primary;\n  border: 1px solid $brand-primary;\n}\n\n.categories-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 40px;\n  margin-bottom: 20px;\n}\n\n.categories-page-btn {\n    width: 38px;\n    height: 38px;\n    border-radius: 8px;\n    border: 1px solid #cbd5e1;\n    background: #fafafa;\n    cursor: pointer;\n    transition: 0.2s;\n    margin-bottom: 5px;\n}\n\n.categories-page-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.categories-page-info {\n  font-size: $font-size-sm;\n  font-weight: $font-weight-semibold;\n  color: $text-primary;\n}\n\n.pagination-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n\n  button {\n    padding: 6px 12px;\n    border-radius: $radius-md;\n    border: 1px solid $border-default;\n    background: $white;\n    cursor: pointer;\n    transition: 0.2s;\n\n    &:hover:not(:disabled) {\n      background: $background-light;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n}\n.categories-header-grid {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  margin-bottom: 10px;\n  padding: 0 24px;\n  min-height: 40px;\n}\n\n.success-msg {\n  font-size: $font-size-md;\n  font-weight: $font-weight-semibold;\n    font-family: $font-family;\n  color: $text-secondary;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: flex-start;\n}\n.success-msg img{\n    width: 20px;\n    height: 20px;\n}\n.select-all {\n  display: inline-flex;\n  align-items: center;\n  font-size: $font-size-md;\n  font-weight: $font-weight-semibold;\n  font-family: $font-family;\n  color: $text-primary;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.select-all input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  accent-color: $brand-primary;\n  margin: 0;\n  cursor: pointer;\n  border-radius: 10px;\n  border: 1px solid $border-dark;\n  background: $white;\n  vertical-align: middle;\n}\n\n.categories-title {\n  font-size: $font-size-xl;\n  font-weight: $font-weight-semibold;\n  color: $text-primary;\n  font-family: $font-family;\n  text-align: left;\n}\n// search bar\n.email-search-bar {\n  width: 85%;\n  padding: 10px 14px;\n  border: 1px solid $brand-primary; \n  border-radius: $radius-md; \n  font-size: $font-size-md;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n  background-color: $white; \nmargin-left: 40px;\n  margin-bottom: 20px;\n}\n\n.search-bar:focus {\n  border-color: $brand-primary;\n  box-shadow: 0 0 0 3px rgba($brand-primary, 0.2); \n  background-color: $white;\n}\n\n.search-bar::placeholder {\n  color: $text-muted; /* muted gray */\n  font-size: $font-size-sm;\n}\n\n.search-input-wrapper {\n  position: relative;\n  display: flex;\n\n}\n.search-icon {\n  position: absolute;\n margin-left: 490px;\n align-items: center;\n  font-size: $font-size-lg;\n  color: $text-muted;\n  cursor: pointer;\n  margin-top: 3px;\n}\n\n//pagination\n.Email-pagination-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 16px;\n  gap: 10px;\n  font-size: $font-size-md;\n}\n\n.Email-pagination-btn {\n  padding: 6px 14px;\n  border: none;\n  border-radius: $radius-md;\n  font-size: $font-size-md;\n  font-weight: $font-weight-semibold;\n  cursor: not-allowed;\n  background-color: $border-default; /* gray when disabled */\n  color: $text-inverse;\n  transition: background-color 0.2s ease-in-out, cursor 0.2s ease-in-out;\n}\n\n.Email-pagination-btn:not(:disabled) {\n  background-color: $brand-primary; /* blue when enabled */\n  cursor: pointer;\n}\n\n.Email-pagination-btn:not(:disabled):hover {\n  background-color: $brand-primary; /* darker blue on hover */\n}\n\n.Email-pagination-separator {\n  margin: 0 6px;\n  color: $text-secondary; /* gray-500 */\n}\n\n.Email-pagination-page {\n  font-weight: $font-weight-semibold;\n  color: $text-secondary; /* gray-700 */\n}\n\n/* --- Final overrides for Step 1 layout --- */\n.categories-header-grid {\n  display: flex !important;\n  align-items: flex-start !important;\n  justify-content: space-between !important;\n  gap: 16px !important;\n  padding: 0 6px !important;\n}\n\n.categories-header-text {\n  margin-top: 10px;\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  gap: 8px !important;\n}\n\n.categories-subtitle {\n  display: inline-block;\n  white-space: nowrap;\n}\n\n.select-all {\n  margin: 0 !important;\n  justify-self: auto !important;\n}\n\n.search-input-wrapper {\n  position: relative !important;\n}\n\n.search-icon {\n  right: 12px !important;\n  left: auto !important;\n  margin: 0 !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n  pointer-events: none;\n}\n\n.email-search-bar {\n  padding-right: 36px !important;\n  padding-left: 12px !important;\n  width: 100% !important;\n  margin-left: 0 !important;\n}\n\n// step 03\n.campaign-type-step {\n  background: $white;\n  border-radius: $radius-lg;\n  padding: 18px 22px 22px;\n  box-shadow: none;\n  border: 1px solid $border-light;\n  max-width: 520px;\n  margin: 24px auto 0;\n}\n.disabled-btn {\n  background-color: $border-light !important;\n  color: $text-muted !important;\n  cursor: not-allowed !important;\n  opacity: 0.7;\n}\n\n.campaign-type-title {\n  font-size: $font-size-lg;\n  font-weight: $font-weight-semibold;\n  color: $text-primary;\n  font-family: $font-family;\n  margin-top: 6px;\n  margin-bottom: 6px;\n}\n.custom-campaign-type-title{\n   font-size: $font-size-xl;\n  font-weight: $font-weight-semibold;\n  color: $text-primary;\n  font-family: $font-family;\n  margin-top:25px;\n  margin-bottom:35px;\n}\n.campaign-type-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr; // 2 columns\n  gap: 10px 16px;\n  margin-top: 14px;\n  margin-bottom: 10px;\n}\n.center-card {\n  grid-column: 1 / -1; \n  justify-self: center; \n  max-width: 220px; \n}\n.campaign-card {\n    border: 1px solid rgb(117, 117, 117);\n    border-radius: 6px;\n    padding: 12px 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    background: #ffffff;\n    width: 100%;\n    text-align: center;\n    min-height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.campaign-card:hover {\n    background: $background-light;\n}\n.ai-back-btn {\n  border-radius: $radius-lg;\n  font-weight: $font-weight-normal;\n  cursor: pointer;\n  font-size: $font-size-md;\n  font-family: $font-family;\n  background: $brand-primary;\n  color: $text-inverse;\nborder: none;\n  transition: background 0.2s ease;\n  \n  /* remove forced min-width */\n  min-width: auto;\n  width: auto;\n  height: 40px;\n  /* make sure text is centered */\n  text-align: center;\n  display: inline-block;\n}\n.ai-back-btn:hover:not(:disabled) {\n  background: $brand-primary-strong;\n    border: none !important;\n}\n.ai-back-btn,\n.ai-next-btn {\n  min-width: 120px; /* both buttons same width */\n  padding: 10px 20px;\n}\n\n@media (max-width: 768px) {\n  .step-nav,\n  .step-nav--categories,\n  .step-nav--campaign {\n    max-width: 100%;\n  }\n\n  .step-nav--with-back {\n    justify-content: space-between;\n  }\n}\n\n.ai-back-btn:disabled {\n    background: $border-dark; \n  color: $text-inverse;      \n  cursor: not-allowed;\n}\n.campaign-card.selected {\n    background-color: rgba(44, 104, 173, 0.18);\n    border-color: #2c68ad;\n}\n.campaign-card.selected .card-title,\n.campaign-card.selected .card-desc {\n    color: $text-dark; \n}\n.card-title {\n  font-weight: $font-weight-semibold;\n  margin-bottom: 0;\n  color: $text-primary;\n  font-family: $font-family;\n  font-size: $font-size-sm;\n  line-height: 1.2;\n  text-align: center;\n  white-space: normal;\n}\n\n.card-desc {\n  font-size: $font-size-xs;\n  color: $text-secondary;\n  font-family: $font-family;\n  font-weight: $font-weight-normal;\n  line-height: 1.25;\n  text-align: center;\n  margin: 0;\n}\n\n\n// step 4\n.ai-prompt-step {\n  background: $white;\n  border-radius: $radius-lg;\n  padding: 24px 32px;\n  max-width: 1000px;\n  margin: 0 auto;\n  margin-top: -30px;\n  margin-bottom: 40px;\n}\n.loading-spinner {\n  margin-left: 8px;\n}\n.prompt-title {\n  font-size: $font-size-xl;\n  font-weight: $font-weight-semibold;\n  margin-bottom: 8px;\n  margin-top: 20px;\n  color: $text-primary;\n  font-family: $font-family;\n}\n\n.prompt-subtitle {\n  font-size: $font-size-sm;\n  color: $text-primary;\n  margin-bottom: 12px;\n  font-weight: $font-weight-normal;\n  font-family: $font-family;\n}\n.tone-title{\n    font-size: $font-size-sm;\n  color: $text-primary;\n  margin-bottom: 12px;\n  font-weight: $font-weight-semibold;\n  font-family: $font-family;\n}\n.prompt-textarea {\n  width: 100%;\n  min-height: 80px;\n  border: 1px solid $border-light;\n  border-radius: $radius-md;\n  padding: 10px;\n  font-size: $font-size-md;\n  margin-bottom: 20px;\n}\n\n.tone-section {\n  margin-bottom: 20px;\n}\n\n.tone-buttons {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.tone-btn {\n  border: 1px solid rgba(117, 117, 117, 1);\n  border-radius: 8px;\n  padding: 6px 14px;\n  background: $white;\n  cursor: pointer;\n  font-size: $font-size-md;\n}\n\n.tone-btn:hover {\n  background: $background-light;\n}\n\n.tone-btn.active {\n    background-color: rgba(44, 104, 173, 0.18);\n    border-color: #2c68ad;\n}\n\n.prompt-input {\n  width: 100%;\n  border: 1px solid $border-light;\n  border-radius: $radius-md;\n  padding: 8px 12px;\n  font-size: $font-size-md;\n  margin-bottom: 12px;\n}\n.form-section {\n  margin-bottom: 16px;\n}\n\n.form-label {\n  display: block;\n  font-size: $font-size-md;\n  font-weight: $font-weight-semibold;\n  margin-bottom: 6px;\n  color: $text-primary;\n}\n\n.prompt-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid $border-light;\n  border-radius: $radius-md;\n  font-size: $font-size-xs;\n  color: $text-primary;\n  font-weight: $font-weight-semibold;\n}\n.form-label {\n  display: block;\n  font-size: $font-size-md;\n  font-weight: $font-weight-semibold;\n  margin-bottom: 6px;\n  color: $text-primary;\n  font-family: $font-family;\n}\n.form-label-cta {\n  display: block;\n  font-size: $font-size-md;\n  font-weight: $font-weight-semibold;\n  margin-bottom: 6px;\n  color: $text-primary;\n  margin-left: 420px;\n  font-family: $font-family;\n}\n.cta-row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cta-labels-row {\n  display: flex;\n  gap: 24px;\n  justify-content: flex-start;\n}\n\n.cta-labels-row .form-label {\n  min-width: 120px;\n  text-align: left;\n}\n\n.cta-inputs-row {\n  display: flex;\n  gap: 24px;\n}\n\n.cta-input-offer {\n  flex: 0 0 12%;   /* small fixed size */\n  padding: 10px 12px;\n  border: 1px solid $border-light;\n  border-radius: $radius-md;\n  font-size: $font-size-md;\n  height: 40px;    /* consistent */\n}\n\n.cta-input-link {\n  flex: 1;         /* takes full remaining space */\n  padding: 10px 12px;\n  border: 1px solid $border-light;\n  border-radius: $radius-md;\n  font-size: $font-size-md;\n  height: 40px;\n}\n\n.cta-input-label {\n  flex: 0 0 25%;   /* medium width */\n  padding: 10px 12px;\n  border: 1px solid $border-light;\n  border-radius: $radius-md;\n  font-size: $font-size-md;\n  height: 40px;\n  color: $text-primary;\n}\n\n.cta-group {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.generate-actions {\n  margin-top: 20px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n}\n\n.generate-btn {\n  width: auto;\n  padding: 10px 16px;\n  background: $brand-primary;\n  color: $text-inverse;\n  font-weight: $font-weight-semibold;\n  font-size: $font-size-md;\n  border: none;\n  border-radius: $radius-md;\n  cursor: pointer;\n  transition: background 0.2s;\n  text-align: center;\n}\n\n.generate-spinner {\n  display: inline-flex;\n  align-items: center;\n}\n\n/* step 5 */\n.review-step {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.campaign-summary-box {\n  background: $white;\n  border: none;\n  border-radius: $radius-md;\n  padding: 24px;\n}\n\n.section-title {\n  font-size: $font-size-xl;\n  font-weight: $font-weight-semibold;\n  margin-bottom: 20px;\n  color: $text-primary;\n}\n\n.summary-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.summary-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px 24px;\n  margin-bottom: 24px;\n  margin-right: 450px;\n}\n.summary-input-wrapper {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n.summary-item label {\n  display: block;\n  font-size: $font-size-md;\n  font-weight: $font-weight-semibold;\n//  margin-bottom: 8px;\n  color: $text-primary;\n  font-family: $font-family;\n}\n\n.input-with-icon-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.edit-icon.inside-input {\n  position: absolute;\n  right: 8px;\n  cursor: pointer;\n  color: $text-secondary;\n  font-size: $font-size-md;\n      margin-right: 20px;\n}\n\n.edit-icon.inside-input:hover {\n  color: $text-primary;\n}\n.edit-icon-Manual {\n  position: absolute;\n  right: 8px;\n  cursor: pointer;\n  color: $text-secondary;\n  font-size: $font-size-md;\n\n}\n.form-input-summary {\n  width: 100%;\n  max-width: 100%;\n  padding-right: 34px !important;\n}\n.form-input-summary[readonly] {\n  background-color: $background-light;\n  border: 1px solid $border-light;\n  cursor: not-allowed;\n}\n\n.edit-icon {\n  margin-left: 8px;\n  font-size: $font-size-lg;\n  color: $text-primary;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.edit-icon:hover {\n  color: $text-primary;\n}\n.form-input:focus {\n  outline: none;\n  border-color: $brand-primary;\n  box-shadow: 0 0 0 2px rgba($brand-primary, 0.2);\n}\n\n.datetime-container {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.datetime-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 30px;\n  width: 66.66%; \n      margin-left: 730px;\n      margin-bottom: 80px;\n      margin-top:-60px;\n}\n.email-editor-campaign{\n  max-width:900px;\n}\n.campaign-summary-heading{\n  color: $text-primary;\n  font-size: $font-size-xl;\n  font-weight: $font-weight-semibold;\n  font-family: $font-family;\n  margin-left: 35px;\n}\n.Email-footer-actions{\n    display: flex;\n  justify-content: flex-end; \n  align-items: center;\n  gap: 12px; \n  margin-top: 20px;\n}\n.date-input-group,\n.time-input-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.date-input-group label,\n.time-input-group label {\n  font-size: $font-size-md;\n  font-weight: $font-weight-semibold;\n  margin-bottom: 8px;\n  color: $text-secondary;\n}\n\n.date-range-inputs {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 70%;       /* take full row */\n}\n\n.date-range-inputs .ant-picker {\n  flex: 1;         \n  min-width: 250px;  \n  height: 3rem;      \n  font-size: $font-size-md;   \n  padding: 0 0.75rem;\n}\n\n.date-input {\n  border: 1px solid $border-default;\n  border-radius: $radius-md;\n  padding: 10px;\n  font-size: $font-size-md;\n  min-width: 140px;\n}\n\n.date-separator {\n  color: $text-muted;\n  font-size: $font-size-md;\n}\n\n.time-input {\n  border: 1px solid $border-default;\n  border-radius: $radius-md;\n  padding: 10px;\n  font-size: $font-size-md;\n  min-width: 120px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 900px) {\n  .datetime-row {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 768px) {\n  .summary-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .datetime-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .summary-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .date-range-inputs {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .date-separator {\n    align-self: center;\n  }\n}\n\n// error message toast\n.ai-error-toast {\n  position: fixed;\n  top: 32px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 2000;\n  background: $white;\n  color: $text-primary;\n  border-radius: $radius-lg;\n  box-shadow: $shadow-md;\n  padding: 10px 12px;\n  display: flex;\n  align-items: center;\n  min-width: 340px;\n  max-width: 90vw;\n  font-size: $font-size-sm;\n  font-weight: $font-weight-normal;\n  border: none;\n  animation: fadeIn 0.3s;\n}\n\n.ai-error-toast .error-icon {\n  background: $danger;\n  color: $text-inverse;\n  border-radius: $radius-round;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: $font-size-xl;\n  margin-right: 16px;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-20px) translateX(-50%);}\n  to { opacity: 1; transform: translateY(0) translateX(-50%);}\n}\n\n.Manual-summary-box{\n  background: $white;\n  border: 1px solid $border-light;\n  border-radius: $radius-md;\n  padding: 24px;\n  box-shadow: $shadow-md;\n}\n.manual-review-step{\n   display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  max-width: 1300px;\n  margin: 0 auto;\n}\n\n.review-send-page {\n  width: 100%;\n}\n\n.review-send-page .review-send-shell {\n  padding: 40px;\n}\n\n.review-send-page .review-send-title-row {\n  margin-bottom: 20px !important;\n}\n\n.review-send-page .form-title,\n.review-send-page .review-summary-heading {\n  margin: 0;\n}\n\n.review-send-page .review-step {\n  padding: 0;\n  max-width: 1200px;\n  width: 100%;\n}\n\n.review-send-page .Manual-summary-box {\n  box-shadow: none;\n}\n\n.review-send-page .summary-grid {\n  grid-template-columns: repeat(3, minmax(220px, 1fr));\n  gap: 24px 48px;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n@media (max-width: 768px) {\n  .review-send-page .review-send-shell {\n    padding: 24px;\n  }\n\n  .review-send-page .summary-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .review-send-page {\n    padding: 12px;\n  }\n\n  .review-send-page .review-send-shell,\n  .review-send-page .Manual-summary-box {\n    padding: 16px;\n  }\n\n  .review-send-page .summary-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.custom-label{\n  display: block;\n  font-size: $font-size-lg;\n  font-weight: $font-weight-semibold;\n  margin-bottom: 6px;\n  color: $text-primary;\n  font-family: $font-family;\n  margin-top: 20px;\n}\n.custom-campaign-form{\n    padding-bottom: 40px;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n/* =========================================\n   📱 MOBILE (max-width: 468px)\n   ========================================= */\n@media (max-width: 468px) {\n  .ai-email-editor-container {\n    padding: 10px;\n    margin-top: 10px;\n  }\n\n  .page-header {\n    flex-direction: row;\n    font-size: $font-size-sm;\n    gap: 8px;\n    align-items: center;\n  }\n\n  .Page-header-text {\n    font-size: $font-size-xs;\n    line-height: 1.4;\n  }\n\n  .email-editor-content {\n    flex-direction: column;\n    gap: 20px;\n    padding: 10px;\n  }\n\n  .left-panel,\n  .right-panel {\n    width: 100%;\n  }\n\n  .form-section {\n    margin: 0;\n  }\n\n  .form-title {\n    font-size: $font-size-xl;\n    margin-bottom: 15px;\n  }\n\n  .form-label {\n    font-size: $font-size-sm;\n  }\n\n  .form-input,\n  .form-textarea {\n    width: 100%;\n    font-size: $font-size-md;\n  }\n\n  .form-textarea {\n    height: 120px;\n  }\n\n  .ai-generator-toggle {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 10px 0;\n  }\n\n  .toggle-switch {\n    align-self: flex-end;\n  }\n\n  .preview-section {\n    margin-top: 20px;\n  }\n\n  .footer-actions {\n    flex-direction: column-reverse;\n    gap: 10px;\n    margin-top: 20px;\n    align-items: stretch;\n  }\n\n  .cancel-btn,\n  .next-btn {\n    width: 100%;\n    min-width: unset;\n    font-size: $font-size-lg;\n    padding: 12px;\n  }\n}\n\n/* =========================================\n   💻 TABLET (max-width: 786px)\n   ========================================= */\n@media (max-width: 786px) {\n  .ai-email-editor-container {\n    padding: 20px;\n  }\n\n  .email-editor-content {\n    flex-direction: column;\n    gap: 25px;\n  }\n\n  .left-panel,\n  .right-panel {\n    width: 100%;\n  }\n\n  .form-section {\n    margin: 0;\n  }\n\n  .form-title {\n    font-size: $font-size-xl;\n  }\n\n  .form-input,\n  .form-textarea {\n    width: 100%;\n  }\n\n  .ai-generator-toggle {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .footer-actions {\n    justify-content: center;\n    gap: 15px;\n    margin-top: 30px;\n  }\n\n  .cancel-btn,\n  .next-btn {\n    min-width: 140px;\n    font-size: $font-size-lg;\n  }\n}\n.schedule-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba($text-primary, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n}\n\n.schedule-modal {\n  background: $white;\n  border-radius: $radius-lg;\n  padding: 24px;\n  width: 100%;\n  max-width: 420px;\n  box-shadow: $shadow-lg;\n  animation: fadeIn 0.25s ease-in-out;\n}\n\n.schedule-picker-title {\n  font-size: $font-size-xl;\n  font-weight: $font-weight-semibold;\n  margin-bottom: 8px;\n  color: $text-primary;\n}\n\n.schedule-picker-paragraph {\n  font-size: $font-size-md;\n  color: $text-secondary;\n  margin-bottom: 16px;\n}\n\n.schedule-picker-presets {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.preset-button {\n  background: $background-light;\n  border: 1px solid $border-default;\n  padding: 10px 12px;\n  border-radius: $radius-md;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n\n  &:hover {\n    background: $border-light;\n  }\n}\n\n.schedule-label {\n  font-size: $font-size-md;\n  color: $text-secondary;\n  display: block;\n  margin-bottom: 6px;\n}\n\n.schedule-input {\n  width: 100%;\n  padding: 10px;\n  border-radius: $radius-md;\n  border: 1px solid $border-default;\n  margin-bottom: 12px;\n  transition: border-color 0.2s ease;\n\n  &:focus {\n    border-color: $brand-primary;\n    outline: none;\n  }\n}\n\n.schedule-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n/* --- Final layout fixes for step 1 header/search --- */\n.page-header {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 0 0 20px;\n  padding: 0 8px;\n  margin-top: 10px;\n}\n\n.back-button--text {\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  background: $brand-primary;\n  color: $text-inverse;\n  border: none;\n  border-radius: $radius-md;\n  padding: 6px 14px;\n  font-size: $font-size-sm;\n  font-weight: $font-weight-semibold;\n  cursor: pointer;\n}\n\n.back-button--text:hover {\n  background: $brand-primary-strong;\n}\n\n.Page-header-text {\n  font-size: $font-size-sm;\n  font-weight: $font-weight-normal;\n  color: $text-secondary;\n  text-align: center;\n  margin-top: 10px;\n  max-width: 75%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.progress-header {\n  width: 100%;\n  margin: 10px 0 28px;\n  margin-left: 0;\n}\n\n.progress-top {\n  padding: 0 2px;\n}\n\n.progress-step {\n  margin-right: 0;\n}\n\n.progress-track {\n  width: 100%;\n}\n\n.categories-header-grid {\n  align-items: flex-start !important;\n}\n\n.select-all {\n  margin-top: 2px !important;\n}\n\n.categories-search {\n  margin: 10px 0 14px;\n}\n\n.categories-search-input.styled-input.ant-input-affix-wrapper {\n  width: 100%;\n  height: 40px;\n}\n\n.categories-search-input .ant-input {\n  padding-right: 30px;\n}\n\n.categories-search-input .ant-input-prefix {\n  display: inline-flex;\n  align-items: center;\n  color: $text-secondary;\n  margin-right: 8px;\n}\n\n.categories-search-input .ant-input-suffix {\n  display: none !important;\n}\n\n.categories-search-icon {\n  font-size: 16px;\n  color: $text-secondary;\n}\n\n@media (max-width: 468px) {\n  .page-header {\n    padding: 0 6px;\n  }\n\n  .Page-header-text {\n    max-width: 60%;\n    font-size: $font-size-xs;\n  }\n\n  .back-button--text {\n    padding: 4px 10px;\n  }\n}\n\n.proceed-button {\n  flex: 1;\n  background: $brand-primary;\n  color: $text-inverse;\n  border: none;\n  padding: 10px;\n  border-radius: $radius-lg;\n  font-weight: $font-weight-semibold;\n  cursor: pointer;\n  transition: background 0.2s ease;\n\n  &:disabled {\n    background: $text-muted;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    background: $brand-primary-strong;\n  }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: scale(0.98); }\n  to { opacity: 1; transform: scale(1); }\n}\n","\n// 🎨 Brand Colors\n$brand-primary: #2c68ad;\n$brand-primary-hover: #2a73c2;\n$brand-primary-strong: #3079bb;\n$brand-primary-light: rgba(44, 104, 173, 0.15);\n$blue-300: #023e8a;\n$blue-400: #03045e;\n$blue-base: #1e3a8a;\n$secondary-blue: #4a90e2;\n$color-1d4ed8: #1d4ed8;\n$color-64748b: #64748b;\n// ⚪ Background / Neutral\n$white: #ffffff;\n$background-default: #f5f6f8;\n$background-light: #fafafa;\n\n// 📝 Text\n$text-primary: #1a1a1a;\n$text-secondary: #6b7280;\n$text-muted: #9ca3af;\n$text-inverse: #ffffff;\n$text-dark: #000000;\n\n// 🧱 Borders\n$border-light: #e5e7eb;\n$border-default: #cbd5e1;\n$border-dark: #9ca3af;\n$border-dropdown: #CCD9F0;\n// 🔴 Status Colors\n$danger: #e53935;\n$danger-hover: #bf3936;\n$text-color: #1a202c;\n$success: #28a745;\n$success-hover: #0cc036;\n$green-100: #d3f9d8;\n$green-700: #2e7d32;\n$gray: #f7f9fc;\n$disabled-gray: #c2c2c2;\n$gray-200: #eeeeee;\n$gray-700: #616161;\n$warning: #ff6c00;\n$chart-primary: $color-1d4ed8;\n$chart-secondary: #0f766e;\n$chart-tertiary: #4338ca;\n$chart-success: $success;\n$chart-warning: $warning;\n$chart-danger: $danger;\n$chart-neutral: $color-64748b;\n$chart-grid-stroke: #e4e8ef;\n$chart-axis-stroke: #d7dde7;\n$chart-tooltip-cursor: rgba(15, 74, 151, 0.08);\n$orange-100: #ff9100;\n$orange-200: #ff6d00;\n$color-003a8c: #003a8c;\n$color-0050b3: #0050b3;\n$color-007bff: #007bff;\n$color-0088cc: #0088cc;\n$color-00a2cc: #00a2cc;\n$color-0172cb: #0172cb;\n$color-04c85e: #04c85e;\n$color-065f46: #065f46;\n$color-0d3b66: #0d3b66;\n$color-f2f2f2: #f2f2f2;\n$color-1c60c6: #1c60c6;\n$color-0d47a1: #0d47a1;\n$color-114b8a: #114b8a;\n$color-130054: #130054;\n$color-140054: #140054;\n$color-145da0: #145da0;\n$color-150054: #150054;\n$color-1565c0: #1565c0;\n$color-165ec9: #165ec9;\n$color-1890ff: #1890ff;\n$color-1977f3: #1977f3;\n$color-1a1a1a: #1a1a1a;\n$color-1b3a57: #1b3a57;\n$color-1d4ed8: #1d4ed8;\n$color-1d5aa1: #1d5aa1;\n$color-1e2a38: #1e2a38;\n$color-1e88e5: #1e88e5;\n$color-1f2d3d: #1f2d3d;\n$color-1f3b65: #1f3b65;\n$color-2196f3: #2196f3;\n$color-222: #222;\n$color-2563eb: #2563eb;\n$color-2596be: #2596be;\n$color-2979ff: #2979ff;\n$color-2a99b4: #2a99b4;\n$color-2b68ad: #2b68ad;\n$color-2c5bbd: #2c5bbd;\n$color-2d4373: #2d4373;\n$color-2e7d32: #2e7d32;\n$color-333: #333;\n$color-34d399: #34d399;\n$color-374151: #374151;\n$color-38abd2: #38abd2;\n$color-3b5998: #3b5998;\n$color-3b82f6: #3b82f6;\n$color-3ec3f0: #3ec3f0;\n$color-40a9ff: #40a9ff;\n$color-475569: #475569;\n$color-4e6a8a: #4e6a8a;\n$color-4f5e71: #4f5e71;\n$color-555: #555;\n$color-595959: #595959;\n$color-64748b: #64748b;\n$color-64b5f6: #64b5f6;\n$color-666: #666;\n$color-718096: #718096;\n$color-75ceeb: #75ceeb;\n$color-777: #777;\n$color-888: #888;\n$color-90caf9: #90caf9;\n$color-91d5ff: #91d5ff;\n$color-92400e: #92400e;\n$color-93c5fd: #93c5fd;\n$color-94a3b8: #94a3b8;\n$color-999: #999;\n$color-a0aec0: #a0aec0;\n$color-a6c1f3: #a6c1f3;\n$color-b91c1c: #b91c1c;\n$color-bac7d5: #bac7d5;\n$color-bae7ff: #bae7ff;\n$color-bbdefb: #bbdefb;\n$color-bbf7d0: #bbf7d0;\n$color-bfdbfe: #bfdbfe;\n$color-c1d6f5: #c1d6f5;\n$color-c7d2fe: #c7d2fe;\n$color-c8e6c9: #c8e6c9;\n$color-cbd5e1: #cbd5e1;\n$color-ccc: #ccc;\n$color-ccd9f0: #ccd9f0;\n$color-d21c1c: #d21c1c;\n$color-d32f2f: #d32f2f;\n$color-d3d3d3: #d3d3d3;\n$color-d93025: #d93025;\n$color-d9d9d9: #d9d9d9;\n$color-d9e2f3: #d9e2f3;\n$color-dbe9ff: #dbe9ff;\n$color-dbeafe: #dbeafe;\n$color-dbeeff: #dbeeff;\n$color-ddd: #ddd;\n$color-e0e0e0: #e0e0e0;\n$color-e0e7ff: #e0e7ff;\n$color-e3f2fd: #e3f2fd;\n$color-e4e4e4: #e4e4e4;\n$color-e53e3e: #e53e3e;\n$color-e5e7eb: #e5e7eb;\n$color-e6f0ff: #e6f0ff;\n$color-e6f4ff: #e6f4ff;\n$color-e6f7ff: #e6f7ff;\n$color-e6f9f0: #e6f9f0;\n$color-e8e8e8: #e8e8e8;\n$color-e8f5e9: #e8f5e9;\n$color-e9effa: #e9effa;\n$color-ecfdf5: #ecfdf5;\n$color-eff6ff: #eff6ff;\n$color-f0f0f0: #f0f0f0;\n$color-f0f2f5: #f0f2f5;\n$color-f0f4ff: #f0f4ff;\n$color-f0f8ff: #f0f8ff;\n$color-f0f9ff: #f0f9ff;\n$color-f1f5f9: #f1f5f9;\n$color-f3f3f3: #f3f3f3;\n$color-f3f4f6: #f3f4f6;\n$color-f5faff: #f5faff;\n$color-f6f9fc: #f6f9fc;\n$color-f87171: #f87171;\n$color-f8f9fa: #f8f9fa;\n$color-f9ee24: #f9ee24;\n$color-f9f9f9: #f9f9f9;\n$color-f9fafb: #f9fafb;\n$color-facc15: #facc15;\n$color-fafafa: #fafafa;\n$color-fde2e2: #fde2e2;\n$color-fecaca: #fecaca;\n$color-fee2e2: #fee2e2;\n$color-fef08a: #fef08a;\n$color-fef2f2: #fef2f2;\n$color-fef9c3: #fef9c3;\n$color-ff4d4f: #ff4d4f;\n$color-ff7875: #ff7875;\n$color-ffcdd2: #ffcdd2;\n$color-ffe0b2: #ffe0b2;\n$color-ffebee: #ffebee;\n$border-color: #cbd5e0;\n$color-00000033: #00000033;\n// 🌫 Shadows\n$shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);\n$shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);\n$shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.2);\n$shadow-button: 0 3px 6px rgba(0, 0, 0, 0.12);\n$shadow-button-subtle: 0 2px 4px rgba(182, 178, 178, 0.6);\n$shadow-gray-600: rgba(182, 178, 178, 0.6);\n$shadow-gray-800: rgba(182, 178, 178, 0.8);\n$shadow-blue-200: rgba(24, 144, 255, 0.2);\n$shadow-black-10: rgba(0, 0, 0, 0.1);\n$shadow-black-08: rgba(0, 0, 0, 0.08);\n$shadow-black-06: rgba(0, 0, 0, 0.06);\n// 📏 Spacing\n$spacing-xs: 4px;\n$spacing-sm: 8px;\n$spacing-md: 12px;\n$spacing-lg: 16px;\n$spacing-xl: 24px;\n\n// ⭕ Border Radius\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-lg: 12px;\n$radius-xl: 20px;\n$radius-round: 50%;\n\n// 🔤 Font\n$font-family: 'Open Sans', sans-serif;\n$font-size-xs: 10px;\n$font-size-sm: 12px;\n$font-size-md: 14px;\n$font-size-lg: 16px;\n$font-size-xl: 20px;\n$font-weight-normal: 400;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n//dashboards\n$dt-primary: #2b74e4;\n$dt-primary-hover: #1f5fc4;\n$dt-text: #1a1a1a;\n$dt-text-secondary: #6b7280;\n$dt-text-muted: #9ca3af;\n$dt-border: #e5e7eb;\n$dt-bg: #f5f6f8;\n$dt-bg-light: #f8fafc;\n$dt-success: #28a745;\n$dt-danger: #e53935;\n$dt-warning: #ff6c00;\n// Chart-palette hues reused by DOM elements (status badges, platform swatches).\n// Keep in sync with CHART_COLOR_PALETTE in src/components/charts/chartPalette.ts.\n$dt-purple: #8d4fd3;\n$dt-google-amber: #f6c15f;\n$paid-media-accent: rgb(43, 104, 173);\n$paid-media-accent-hover: rgb(43, 104, 173);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
